import React from 'react';
import Education from '../../components/Education';

function EducationPage() 
    {
     return (
         <div>
        {/* <Header></Header> */}
        <Education></Education>
        
        </div>
     )
     
    }
export default EducationPage;